import clsx from "clsx";
import styles from "./spinner.module.css";

type Props = React.HTMLAttributes<HTMLDivElement>;

const Spinner: React.FC<Props> = ({ className, ...props }) => {
  return (
    <div className={clsx(className, styles["lds-roller"])} {...props}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export { Spinner };
